import {gsap} from "gsap";
import {createApp} from 'vue';

const app = createApp({
    name: "Insta-app",
    data() {
        return {
            ready: false,
            columns: null,
            profilePic: instaData.profilePic,
            mobile: true,
        }
    },
    computed: {

    },
    methods: {
        start() {

            let app = this;
            this.ready = true;
            setInterval(() => app.tick(), 5000);

            // Set height of container so that onbly three items will be shown
            this.$nextTick(function(){
                let item = document.querySelector('.' + app.columns[0][0].class);
                let heightNum = this.mobile ? 1 : 3;
                if(!this.mobile){
                    document.getElementById('insta-app').style.height = (item.clientHeight * heightNum) + 'px';

                }
            } );
        },
        checkMobile() {
          return window.innerWidth < 768;
        },
        fixColumns() {
            let count = 5;
            if(this.mobile){
                this.columns = [instaData.posts.slice(0, count)];
            } else {
                this.columns = [instaData.posts.slice(0, count), instaData.posts.slice(count)];
            }
        },
        tick() {
            let app = this;
            let animationSeconds = 2;
            let delay = 0;

            if(!this.columns.length) return;

            this.columns.forEach(function(col){

                if(!col.length) return;

                col.forEach(function(item){
                    let el = document.querySelector('.' + item.class);
                    delay += 0.03;

                    if(app.mobile){
                        gsap.to(el, {
                            xPercent: -100,
                            duration: 1,
                            delay: delay,
                            ease: 'elastic.out(1, 0.75)'
                        });
                    } else {
                        gsap.to(el, {
                            yPercent: -100,
                            duration: 1,
                            delay: delay,
                            ease: 'elastic.out(1, 0.75)'
                        });
                    }

                });
            });

            setTimeout(function(){
                app.updateArrays();
            },(animationSeconds*1000) + (delay*1000) + 100);


        },
        updateArrays(){
            let app = this;
            // Move items out of view to the beginning creating a loop illusion
            this.columns.forEach(function(col){
                col.forEach(function(item){
                    let el = document.querySelector('.' + item.class);
                    if(app.mobile){
                        gsap.to(el, {
                            xPercent: 0,
                            duration: 0,
                        });
                    } else {
                        gsap.to(el, {
                            yPercent: 0,
                            duration: 0,
                        });
                    }

                });

                col.push(col.shift());
            });
        }
    },
    mounted() {
        // Decide on mobile
        this.mobile = this.checkMobile();

        this.fixColumns();
        this.start();

    }
});

// Mount app to DOM
if (document.getElementById("insta-app")) {
    app.mount('#insta-app');
}